import { useQuery } from '@tanstack/react-query'
import api from './api'

/**
 * Pacote de dados pra renderizar o certificado via html2canvas.
 * Back resolve fallback empresa→global antes de devolver.
 */
export interface CertificateData {
  userName: string
  courseTitle: string
  /** ISO string */
  completedAt: string
  /** URL do template; pode ser null se nem empresa nem global cadastraram */
  backgroundUrl: string | null
  /** Logo da empresa (reusa companies.logo); null se a empresa não tem */
  companyLogoUrl: string | null
  signature: {
    company?: { url: string; name: string; role: string | null }
    global?: { url: string; name: string; role: string | null }
  }
  /**
   * Badges pra exibir na faixa horizontal do certificado. Back já fez
   * intersect com `user_badges` (só vem o que o user conquistou) e
   * filtrou as sem `iconUrl`. Vazio = faixa some.
   */
  badges: Array<{ id: string; name: string; iconUrl: string }>
}

/**
 * Busca os dados do certificado pra um curso específico.
 *
 * Back retorna:
 * - 404 NO_ENROLLMENT se user não está matriculado
 * - 403 NOT_COMPLETED se completedAt é null
 * - 200 com `CertificateData` caso contrário
 *
 * Hook habilita só com courseId válido — preview pode passar
 * `undefined` antes de saber o curso.
 */
export function useCertificateData(courseId: number | undefined) {
  return useQuery({
    queryKey: ['certificate-data', courseId],
    queryFn: async () => {
      const response = await api.get<CertificateData>('/certificates/data', {
        params: { courseId },
      })
      return response.data
    },
    enabled: !!courseId,
    // Templates podem mudar (admin troca PNG) — refresh em background
    // ao reabrir a tela é desejável. Stale=0 garante isso.
    staleTime: 0,
  })
}
